/**
 * IP Signature utility for cross-browser Meta user identification
 * Fetches IP-based signature from Cloud Function via hosting rewrite
 */

/**
 * Fetches IP-based signature from Cloud Function
 * Uses relative path /ipSig which is rewritten to Cloud Function via firebase.json
 * @returns {Promise<string|null>} IP signature hash or null if failed
 */
export async function getIpSignature() {
  try {
    // Get timezone for better signature stability
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";

    const response = await fetch("/ipSig", {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'X-Timezone': tz,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    const data = await response.json();
    console.log('[IP] ipSig:', data.ipSig?.slice(0, 16) + '...');
    return data.ipSig;
  } catch (error) {
    console.warn('⚠️ Failed to get IP signature:', error);
    return null;
  }
}
